// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__select {
  position: relative;
  font-size: 13px;
}
.avo__select .select-wrapper {
  cursor: pointer;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #cdd5df;
  padding: 8px 12px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  height: 36px;
}
.avo__select .select-wrapper.select-wrapper-items {
  padding: 4px 7px;
  height: auto;
}
.avo__select .select-wrapper.disabled {
  border-color: #cdd5df;
  background: #f9fafb;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);
  color: #97a2b6;
}
.avo__select .select-wrapper input {
  position: absolute;
  left: 12px;
  outline: none;
  box-shadow: none;
  font-size: 13px;
  padding: 0px;
  border: none;
}
.avo__select .select-wrapper input.input-multiple-select {
  position: static;
}
.avo__select .select-wrapper img {
  width: 16px;
  height: 16px;
  margin-left: auto;
}
.avo__select .select-wrapper .wrapper-items {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  padding-left: 2px;
}
.avo__select .select-wrapper .wrapper-items .selected-multiple-item {
  display: flex;
  align-items: center;
  justify-items: center;
  padding: 3px 7px;
  margin-right: 5px;
  border: 1px solid #ebf0f6;
  cursor: auto;
  border-radius: 8px;
}
.avo__select .select-wrapper .wrapper-items .selected-multiple-item .text-item {
  color: #101728;
  padding-right: 7px;
}
.avo__select .select-wrapper .wrapper-items .selected-multiple-item .ic-close {
  cursor: pointer;
}
.avo__select .select-wrapper .wrapper-item {
  display: flex;
  align-items: center;
  padding-left: 2px;
}
.avo__select .select-wrapper .selected-item {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.avo__select .select-wrapper .selected-item.placeholder {
  color: #788192;
  font-family: "OpenSans-Regular";
}
.avo__select .options-wrapper {
  position: absolute;
  z-index: 10;
  padding: 6px;
  width: 100%;
  white-space: nowrap;
  border-radius: 8px;
  border: 1px solid #ebf0f6;
  background: #ffffff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  overflow: auto;
}
.avo__select .options-wrapper.below {
  margin-top: 4px;
}
.avo__select .options-wrapper.above {
  margin-bottom: 4px;
  bottom: 100%;
}
.avo__select .options-wrapper.show {
  opacity: 1;
  visibility: visible;
}
.avo__select .options-wrapper.hide {
  opacity: 0;
  visibility: collapse;
}
.avo__select .options-wrapper .option-item {
  padding: 10px 16px;
}
.avo__select .options-wrapper .option-item:hover {
  background-color: #f9fafb;
  border-radius: 8px;
  cursor: pointer;
}
.avo__select .options-wrapper .no-option {
  padding: 4px 16px;
  text-align: center;
  color: #788192;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/select/select.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,eAAA;AADJ;AAGI;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;AADR;AAGQ;EACI,gBAAA;EACA,YAAA;AADZ;AAIQ;EACI,qBClBC;EDmBD,mBCrBC;EDsBD,+CAAA;EACA,cCnBC;ADiBb;AAKQ;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAHZ;AAKY;EACI,gBAAA;AAHhB;AAOQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AALZ;AAQQ;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;AANZ;AAQY;EACI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;AANhB;AAQgB;EACI,cCxDP;EDyDO,kBAAA;AANpB;AASgB;EACI,eAAA;AAPpB;AAYQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;AAVZ;AAaQ;EACI,gBAAA;EACA,oBAAA;EACA,4BAAA;EACA,qBAAA;AAXZ;AAaY;EACI,cCjFH;EDkFG,+BAAA;AAXhB;AAgBI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBCzGA;ED0GA,gDAAA;EACA,wBAAA;EACA,wDAAA;EACA,0BAAA;EACA,cAAA;AAdR;AAgBQ;EACI,eAAA;AAdZ;AAiBQ;EACI,kBAAA;EACA,YAAA;AAfZ;AAkBQ;EACI,UAAA;EACA,mBAAA;AAhBZ;AAmBQ;EACI,UAAA;EACA,oBAAA;AAjBZ;AAoBQ;EACI,kBAAA;AAlBZ;AAmBY;EACI,yBCjIH;EDkIG,kBAAA;EACA,eAAA;AAjBhB;AAqBQ;EACI,iBAAA;EACA,kBAAA;EACA,cCrIC;ADkHb","sourcesContent":["@import '../../../styles/color';\n\n.avo__select {\n    position: relative;\n    font-size: 13px;\n\n    .select-wrapper {\n        cursor: pointer;\n        width: 100%;\n        border-radius: 8px;\n        border: 1px solid $neutral-30;\n        padding: 8px 12px;\n        background: white;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        overflow: hidden;\n        height: 36px;\n\n        &.select-wrapper-items {\n            padding: 4px 7px;\n            height: auto;\n        }\n\n        &.disabled {\n            border-color: $neutral-30;\n            background: $neutral-10;\n            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06);\n            color: $neutral-50;\n        }\n\n        input {\n            position: absolute;\n            left: 12px;\n            outline: none;\n            box-shadow: none;\n            font-size: 13px;\n            padding: 0px;\n            border: none;\n\n            &.input-multiple-select {\n                position: static;\n            }\n        }\n\n        img {\n            width: 16px;\n            height: 16px;\n            margin-left: auto;\n        }\n\n        .wrapper-items {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 4px;\n            padding-left: 2px;\n\n            .selected-multiple-item {\n                display: flex;\n                align-items: center;\n                justify-items: center;\n                padding: 3px 7px;\n                margin-right: 5px;\n                border: 1px solid $neutral-20;\n                cursor: auto;\n                border-radius: 8px;\n\n                .text-item {\n                    color: $neutral-80;\n                    padding-right: 7px;\n                }\n\n                .ic-close {\n                    cursor: pointer;\n                }\n            }\n        }\n\n        .wrapper-item {\n            display: flex;\n            align-items: center;\n            padding-left: 2px;\n        }\n\n        .selected-item {\n            overflow: hidden;\n            display: -webkit-box;\n            -webkit-box-orient: vertical;\n            -webkit-line-clamp: 1;\n\n            &.placeholder {\n                color: $neutral-60;\n                font-family: 'OpenSans-Regular';\n            }\n        }\n    }\n\n    .options-wrapper {\n        position: absolute;\n        z-index: 10;\n        padding: 6px;\n        width: 100%;\n        white-space: nowrap;\n        border-radius: 8px;\n        border: 1px solid $neutral-20;\n        background: $white;\n        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);\n        transition-property: all;\n        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n        transition-duration: 200ms;\n        overflow: auto;\n\n        &.below {\n            margin-top: 4px;\n\n        }\n        &.above {\n            margin-bottom: 4px;\n            bottom: 100%\n        }\n\n        &.show {\n            opacity: 1;\n            visibility: visible;\n        }\n\n        &.hide {\n            opacity: 0;\n            visibility: collapse;\n        }\n\n        .option-item {\n            padding: 10px 16px;\n            &:hover {\n                background-color: $neutral-10;\n                border-radius: 8px;\n                cursor: pointer;\n            }\n        }\n\n        .no-option {\n            padding: 4px 16px;\n            text-align: center;\n            color: $neutral-60;\n        }\n    }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
